import { request } from '.';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getData = <T = any>(url: string) => {
  return request<T>(url);
};
